import Vue from 'vue'

const fetchAll = () => {
  return Vue.prototype.$http.get('operators/')
}

const fetchByMethod = (method) => {
  return Vue.prototype.$http.get(`operators/method/${method}`)
}

export default {
  fetchAll,
  fetchByMethod,
}
